<template>
  <div v-if="examRequestItems.length" class="exam-list">
    <div v-for="(examRequestItem, index) in examRequestItems" :key="examRequestItem.id_exam" class="exam-item">
      <span class="exam-item-index">{{ index + 1 }}</span>
      <div class="exam-item-body">
        <div class="exam-item-top">
          <div class="exam-item-identity">
            <span class="exam-item-name">{{ examRequestItem.exam_name }}</span>
          </div>
          <div class="exam-item-aside">
            <span v-if="examRequestItem.exam_tuss_code" class="exam-item-tuss">
              TUSS {{ examRequestItem.exam_tuss_code }}
            </span>
            <div v-if="!readonly && !examRequest.exam_request_generated" class="exam-item-actions">
              <button type="button" class="btn btn-icon btn-sm btn-bg-light btn-active-color-primary"
                      @click="deleteExamRequestItem(examRequestItem.id_exam)"
                      title="Excluir exame">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="exam-list-empty">
    <i class="bi bi-clipboard-x"></i>
    <span>Nenhum exame adicionado a este pedido.</span>
  </div>

  <div v-if="!readonly && !examRequest.exam_request_generated" class="exam-add-inline">
    <label class="form-label">Adicionar exame</label>
    <InputSearchExam v-model="searchExam" @onSetSearchExam="addExamFromSearch"/>
  </div>
</template>

<script>
import http from "../../../helpers/http";
import Alert from "../../../helpers/alert";
import InputSearchExam from "../../../components/InputSearchExam";

export default {
  name: "ExamRequestItems",
  components: {InputSearchExam},
  props: {
    examRequest: Object,
    schedule: Object,
    readonly: false,
  },
  data() {
    return {
      examRequestItems: [],
      searchExam: '',
    }
  },
  mounted() {
    this.examRequestItems = this.examRequest.exams;
  },
  methods: {
    getExamRequestItems() {
      http.get(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.examRequest.id_medrec}/exam-requests/${this.examRequest.id_exam_request}/exams`).then((response) => {
        this.examRequestItems = response.data;
      });
    },
    deleteExamRequestItem(examId) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o exame?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.examRequest.id_medrec}/exam-requests/${this.examRequest.id_exam_request}/exams/${examId}`).then(_ => {
            this.getExamRequestItems();
            Alert.toastSuccess("Exame excluÍdo com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    addExamFromSearch(exam) {
      if (!exam?.id_exam) {
        return;
      }
      if (this.examRequestItems.some((item) => item.id_exam === exam.id_exam)) {
        Alert.toastWarning('Este exame já está no pedido.');
        this.searchExam = '';
        return;
      }

      this.submitFormStoreExam({id_exam: exam.id_exam});
      this.searchExam = '';
    },
    submitFormStoreExam(formStoreExam) {
      formStoreExam.id_exam_request = this.examRequest.id_exam_request;
      http.post(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.examRequest.id_medrec}/exam-requests/${this.examRequest.id_exam_request}/exams`, formStoreExam).then(_ => {
        this.getExamRequestItems();
        Alert.toastSuccess("Exame cadastrado com sucesso.");
      }).catch(e => {
        Alert.toastError(e.response.data.message??e.response.data);
      });
    }
  }
}
</script>

<style scoped>

/* A tabela dava quatro colunas para duas informacoes: o nome do exame ficava
   espremido numa coluna estreita e quebrava em varias linhas. Em lista, o nome
   usa a largura toda e o codigo TUSS vira um chip lateral. Mesmo layout da
   listagem de medicamentos da prescricao. */
.exam-list {
  border-top: 1px solid #eef0f2;
}

.exam-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 2px;
}

.exam-item + .exam-item {
  border-top: 1px solid #eef0f2;
}

.exam-item-index {
  flex-shrink: 0;
  width: 18px;
  padding-top: 2px;
  color: #6c757d;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.4;
  text-align: right;
}

.exam-item-body {
  flex: 1;
  min-width: 0;
}

.exam-item-top {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.exam-item-identity {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  min-width: 0;
  flex: 1 1 160px;
}

.exam-item-name {
  font-weight: 600;
  color: #212529;
  line-height: 1.35;
  overflow-wrap: break-word;
}

.exam-item-aside {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  margin-left: auto;
}

.exam-item-tuss {
  padding: 2px 8px;
  border-radius: 6px;
  background: #f1f3f5;
  color: #495057;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.exam-item-actions {
  display: flex;
  gap: 4px;
}

.exam-item-actions .btn {
  width: 32px;
  height: 32px;
}

.exam-list-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px dashed #e4e6ef;
  border-radius: 8px;
  padding: 12px;
  background: #fcfcfd;
  color: #6c757d;
  font-size: 0.875rem;
}

.exam-add-inline {
  margin-top: 4px;
  padding: 16px 2px 2px;
  border-top: 1px solid #eef0f2;
}

</style>
